module.exports = __webpack_public_path__ + "img/Dropdown.04eb565f.svg";